import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import VideoGrid from './components/VideoGrid';
import { videos } from '@/mocks/videos';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const hotVideos = videos.filter((v) => v.isHot);
  const newVideos = videos.filter((v) => v.isNew);
  const movieVideos = videos.filter((v) => v.category === 'movie');
  const tvVideos = videos.filter((v) => v.category === 'tv');

  return (
    <>
      <SEO
        title="菠萝视频 - 海量高清视频在线观看平台"
        description="菠萝视频是一款提供海量高清视频内容的在线播放平台，涵盖电影、电视剧、综艺、动漫等多种类型，支持免费流畅观看。菠萝视频让你随时随地享受优质视频娱乐体验。"
        keywords="菠萝视频,菠萝视频在线观看,菠萝视频免费播放,菠萝视频高清电影,菠萝视频电视剧大全,菠萝视频最新综艺,菠萝视频官网入口"
        canonicalUrl="https://www.boluovideo.com/"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategorySection />
          <VideoGrid
            title="热门推荐"
            subtitle="全网最热视频，大家都在看"
            videos={hotVideos}
            linkTo="/category/movie"
          />
          <VideoGrid
            title="最新上线"
            subtitle="新鲜出炉，抢先观看"
            videos={newVideos}
            linkTo="/category/variety"
          />
          <div className="bg-background-100/70">
            <VideoGrid
              title="热门电影"
              videos={movieVideos.slice(0, 6)}
              linkTo="/category/movie"
            />
            <VideoGrid
              title="热门剧集"
              videos={tvVideos.slice(0, 6)}
              linkTo="/category/tv"
            />
          </div>
          <VideoGrid
            title="全部推荐"
            subtitle="发现更多精彩内容"
            videos={videos}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}